import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import Tooltip from "@/tooltip";
import { Actions as OVERTIMEACTIONS } from "@/redux/actions/overtimeActions";
import { Actions as COMPANYACTIONS } from "@/redux/actions/companyActions";
import { Cog8ToothIcon } from "@heroicons/react/20/solid";
import { validateFloat } from "@/common/validation/Validators";
import { useEffect } from "react";

const typeOptions = [
	{ label: "Paid", value: false },
	{ label: "Time Off in Lieu", value: true },
];

const OvertimeRow = ({
	overtime,
	updateSetting,
	updateAdvisorSetting,
	disabled,
	openModal,
	forModal,
	advisor,
	template,
}) => {
	useEffect(() => {
		if (!forModal && !template) return;

		updateSetting(overtime.id, "name", overtime?.name);
		updateSetting(overtime.id, "rate", overtime?.rate);
		updateSetting(overtime.id, "isToil", overtime?.isToil);
	}, [advisor]);
	return (
		<div className="col-xs-12 form-inner-section pr-0 mb-0 pb-0 pt-6">
			<div
				className="col-xs-5"
				style={{ paddingLeft: 0 }}
			>
				<div className="form-material">
					<input
						id="overtime-type-name"
						className="form-control form-input"
						type="text"
						disabled={disabled || template}
						name="name"
						required
						onChange={(e) =>
							advisor
								? updateAdvisorSetting(overtime.id, e.target.name, e.target.value)
								: updateSetting(overtime.id, e.target.name, e.target.value)
						}
						defaultValue={overtime.name}
					/>
					<label htmlFor="material-text">Name</label>

					{/* <div className="help-block animated fadeInDown first-overtime-type-name hide">
              Give a custom, recognisable name to the Overtime type you’re going
              to create.
            </div> */}
				</div>
			</div>

			<div className="col-xs-3">
				<div className="form-material">
					<input
						id="overtime-type-rate"
						className="form-control valid form-input"
						type="text"
						name="rate"
						disabled={disabled || template}
						required
						onChange={(e) =>
							advisor
								? updateAdvisorSetting(overtime.id, e.target.name, validateFloat(e.target.value))
								: updateSetting(overtime.id, e.target.name, validateFloat(e.target.value))
						}
						defaultValue={overtime.rate}
					/>
					<label htmlFor="material-text">Rate</label>

					{/* <div className="help-block animated fadeInDown first-overtime-type-rate hide">
              Now, enter a multiplier (e.g. 1, 1.5) of the original salary -
              this is the rate at which this Overtime will be paid.
            </div> */}
				</div>
			</div>

			<div className="col-xs-3 pr-0">
				<div className="form-material">
					<Select
						valueName="selected"
						options={typeOptions}
						value={typeOptions.find((item) => item.value == overtime.isToil)}
						placeholder="Choose one"
						isDisabled={disabled || template}
						onChange={(e) =>
							advisor
								? updateAdvisorSetting(overtime.id, "isToil", e.value)
								: updateSetting(overtime.id, "isToil", e.value)
						}
					/>
					<label htmlFor="material-text">Type</label>

					<div className="clearfix" />
				</div>
			</div>

			<div className="col-xs-1">
				{!forModal && !disabled && !advisor ? (
					<div
						className="pull-right"
						onClick={() => openModal(overtime.id)}
						style={{ marginTop: "1.25em", cursor: "pointer" }}
					>
						<Tooltip content="Advanced Settings">
							<Cog8ToothIcon style={{ height: "2em" }} />
						</Tooltip>
					</div>
				) : null}
			</div>
			<div className="clearfix" />
		</div>
	);
};
const mapStateToProps = (state) => {
	return {
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateSetting: (id, field, newValue) =>
		dispatch(OVERTIMEACTIONS.updateSetting(id, field, newValue, !!ownProps.forModal)),
	updateAdvisorSetting: (id, field, newValue) => dispatch(OVERTIMEACTIONS.updateAdvisorSetting(id, field, newValue)),
	openModal: (overtime) => dispatch(COMPANYACTIONS.advancedSettingsModal(overtime, "Overtime")),
});

export default connect(mapStateToProps, mapDispatchToProps)(OvertimeRow);
